import useMenuItems from './useMenuItems';
import {
  StyledFilterSetMenu,
  StyledMenuHeader,
  StyledMenuItem
} from './FilterSetMenu.style';
import useRecentFilterSetsMenuItems from './useRecentFilterSetsMenuItems';

const FilterSetMenu = ({ anchorEl, setAnchorEl, Context }) => {
  const isOpen = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuItems = useMenuItems(Context);
  const recentFilterSetsMenuItems = useRecentFilterSetsMenuItems(Context);

  const renderMenuItem = item => {
    const { Icon } = item;
    return (
      <StyledMenuItem
        key={item.label}
        onClick={() => {
          item.onClick();
          handleClose();
        }}
        data-cy={`filter-set-${item.label.replace(/ /g, '-')}`}
      >
        {Icon && <Icon />}
        {item.label}
      </StyledMenuItem>
    );
  };

  return (
    <StyledFilterSetMenu
      id='filter-set-menu'
      anchorEl={anchorEl}
      open={isOpen}
      onClose={handleClose}
      onBlur={handleClose}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
    >
      {menuItems.map(item => renderMenuItem(item))}

      {!!recentFilterSetsMenuItems?.length && (
        <>
          <StyledMenuHeader>Recently Viewed</StyledMenuHeader>
          {recentFilterSetsMenuItems.map(item => renderMenuItem(item))}
        </>
      )}
    </StyledFilterSetMenu>
  );
};

export default FilterSetMenu;
